module.exports = __webpack_public_path__ + "assets/img/img270.a07e6b2c.png";